document.addEventListener('DOMContentLoaded', () => {
    const blockList = document.querySelectorAll('.fade-block')

    if (blockList.length) {
        blockList.forEach((block) => { 
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const tl = gsap.timeline();
                            tl.to(block, {
                                duration: 1.5,
                                delay: block.dataset.delay,
                                opacity: 1,
                                y: 0,
                                ease: 'power4.out'
                            });

                            observer.unobserve(block);
                        }
                    });
                },
                {
                    threshold: 0.3,
                }
            );

            observer.observe(block);
        })
    }
})